import React from 'react';
import TeamList from '../../teams/components/TeamList';

/**
 * TeamsTab - Display user's teams
 *
 * @param {Object} props
 * @param {number|string} props.userId - User ID to fetch teams for
 */
export default function TeamsTab({ userId }) {
  if (!userId) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">User ID is required to display teams</p>
      </div>
    );
  }

  return (
    <TeamList
      ownerType="user"
      ownerId={userId}
      showCreateButton={true}
      showHeader={true}
      title="My Teams"
      emptyMessage="No teams yet"
      emptyDescription="Create your first team or join an existing one"
      createButtonText="Create Team"
      baseUrl="/profile/teams"
    />
  );
}
